<img *ngIf="profile[userMetadata]?.picture"
    alt="Profile picture" class="nav-user-profile rounded-circle" [width]="size" [height]="size"
    [src]="profile[userMetadata]?.picture | versionUrl">

<div *ngIf="!profile[userMetadata]?.picture"
    class="nav-user-profile rounded-circle text-center mx-auto text-white"
    [style]="style">
    {{firstName[0]}}{{lastName[0]}}
</div>
